module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: [_vm.theme, this.isOpen ? '' : 'collapsed-box', _vm.isSolid ? 'box-solid' : '']
  }, [_c('div', {
    staticClass: "box-header",
    class: (_vm.isBorder || _vm.isSolid) ? 'with-border' : ''
  }, [_vm._t("icon-title"), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [(_vm.btnIcon) ? _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": _vm.widgetType
    }
  }, [_c('i', {
    class: _vm.btnIcon
  })]) : _vm._e(), _vm._v(" "), (_vm.list) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem),
      expression: "selectedItem"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Select Dealer")]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("content")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), (this.isLoading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d6e2c5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VABox.vue
// module id = 697
// module chunks = 0